import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';

import type { QueryResult, UseQuery } from '../../../types';

type AccountId = number;
type PlanId = string;

type PlanTier = {
  numTasks: number;
  pricePerTask: number;
};

type Account = {
  id: AccountId;
  name: string;
  plan: {
    amount: number;
    hasMeteredBilling: boolean;
    id: PlanId;
    name: string;
    tiers: Array<PlanTier>;
  };
  usage: {
    periodEnd: string;
    tasks: {
      limit: number;
      on: number;
      total: number;
    };
    zaps: {
      limit: number;
      on: number;
      total: number;
    };
  };
};

type SidebarQueryVariables = {
  accountId: AccountId;
};

type SidebarQueryResponse = {
  isAuthenticatedV2: boolean;
  account: Account;
};

type Arguments = {
  accountId: AccountId;
  useQuery: UseQuery;
};

type Result = QueryResult<SidebarQueryResponse>;

/* eslint-disable graphql/no-deprecated-fields */
export const sidebarDataQuery: DocumentNode = gql`
  query sidebarDataQuery($accountId: Int!) {
    isAuthenticatedV2
    account(id: $accountId) {
      id
      name
      plan {
        amount
        hasMeteredBilling
        name
        id
        tiers {
          numTasks
          pricePerTask
        }
      }
      usage {
        periodEnd
        tasks {
          limit
          total
        }
        zaps {
          limit
          on
        }
      }
    }
  }
`;
/* eslint-enable graphql/no-deprecated-fields */

/**
 * Hook that provides data used for the global navigation.
 */
const useSidebarData = ({ accountId, useQuery }: Arguments): Result => {
  const variables: SidebarQueryVariables = {
    accountId,
  };

  const result: Result = useQuery(sidebarDataQuery, { ssr: false, variables });

  return result;
};

export default useSidebarData;
